import {ButtonGroup as PeacockButtonGroup} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').IButtonGroupProps} ButtonGroupProps
 * @property {{ icon?: string | import('react').SVGProps<SVGSVGElement>; label: string; onClick?: import('react').MouseEventHandler<HTMLButtonElement>; disabled?: boolean; }[]} items Button group items.
 * @property {boolean} [groupDisabled] When true, all buttons in the group are disabled.
 * @property {'large' | 'medium' | 'small'} [size] Button group size. Defaults to medium.
 * @property {number} [itemCount] Number of button group items to render.
 * @property {boolean} [showMore] When true, shows a dropdown for overflow items.
 * @property {'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'} [menuPosition] Dropdown menu position. Defaults to bottom-right.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS ButtonGroup.
 * Supports all Peacock DS button group props.
 * @param {ButtonGroupProps} props
 */
export const ButtonGroup = props => {
  return <PeacockButtonGroup {...props} />
}
